<script setup>
import { defineProps } from 'vue';
import { Book, Globe, User, Users, Music, GraduationCap } from 'lucide-vue-next';
import { useThemeStore } from '../../stores/themeStore';
const themeStore = useThemeStore();
const props = defineProps({
  whyChooseUsItems: Array,
});

const iconComponents = {
  Book,
  Globe,
  User,
  Users,
  Music,
  GraduationCap,
};
</script>

<template>
  <section class="py-24 px-4 md:px-8 lg:px-16 bg-white   ">
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold mb-4">{{ themeStore.theme.whyChooseUs.title }}</h2>
      <p class="text-text-light max-w-2xl mx-auto">
        {{ themeStore.theme.whyChooseUs.subtitle }}
      </p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div v-for="(item, index) in  themeStore.theme.whyChooseUs.cards" :key="index"
        class="bg-white text-black p-6 rounded-lg shadow-lg flex items-start gap-4 transform transition-all  cursor-pointer duration-300 hover:scale-[1.02] hover:shadow-lg">
        <div class="bg-bright-yellow p-3 rounded-full flex-shrink-0">
          <component :is="iconComponents[item.icon]" :size="24" class="text-black" />
        </div>
        <div>
          <h3 class="text-xl font-semibold mb-2">{{ item.title }}</h3>
          <p class="text-text-light text-sm">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
